import { render, staticRenderFns } from "./pageContentEdit.vue?vue&type=template&id=e318b06e&scoped=true&"
import script from "./pageContentEdit.vue?vue&type=script&lang=js&"
export * from "./pageContentEdit.vue?vue&type=script&lang=js&"
import style0 from "./pageContentEdit.vue?vue&type=style&index=0&id=e318b06e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e318b06e",
  null
  
)

export default component.exports